// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paddingTopBottom {
  padding-top: 15px;
  padding-bottom: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/content/layout/components/modals/create-account-modal/create-account-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,oBAAA;AACF","sourcesContent":[".paddingTopBottom {\n  padding-top: 15px;\n  padding-bottom: 15px\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
